import React from "react";
import {
  destroyUserDatabaseAuthenticationSessionPath,
  newPostPath,
  rootPath
} from "../../../../../../routes";
import { LogoSVG } from "../../../../svg";
import { SharedCurrentUser } from "../../../lib/types";
import useRequest from "../../../lib/useRequest";
import SmsIcon from "../../icons/SmsIcon";

import { Helmet } from "react-helmet";
import Button from "../../ui/Button";
import HeaderDrawerWithButton from "../HeaderDrawerWithButton";
import MessagesButton from "../MessagesButton";
import ReadonlyUserAlert from "../ReadonlyUserAlert";

import { Box, Flex, HStack, Image, Link, Menu, Show, Stack } from "@chakra-ui/react";
import { HeaderLoginActions } from "../HeaderLoginActions";
import { Profile } from "./Profile";
import { ProfileMenuList } from "./ProfileMenuList";
import { ServiceLinks } from "./ServiceLinks";

const GeneralHeader = ({
  currentUser,
  shadow = true,
  sticky = true,
  variant = "default",
  hideAuthActions = false,
}: {
  currentUser?: SharedCurrentUser;
  shadow?: boolean;
  sticky?: boolean;
  variant?: "default" | "minimal";
  hideAuthActions?: boolean;
}) => {
  const request = useRequest();

  const logout = async () => {
    const res = await request(destroyUserDatabaseAuthenticationSessionPath(), "DELETE");

    if (res.ok) {
      location.href = "/";
    }
  };
  const isMinimal = variant === "minimal";
  return (
    <Box position={sticky ? "sticky" : "static"} top={sticky ? "0px" : undefined} zIndex={sticky ? "100" : undefined}>
      {sticky && (
        <Helmet>
          <style type="text/css">{`
            html {
              scroll-padding-top: 56px;
            }
          `}</style>
        </Helmet>
      )}
      {currentUser?.is_readonly_user && <ReadonlyUserAlert />}
      <Flex
        bg="white"
        boxShadow={shadow ? "0px 4px 12px 0px rgba(10, 100, 79, 0.08)" : undefined}
        zIndex={2}
        pl={{ base: "16px", md: 6 }}
        justify="space-between"
        h={14}
        position={sticky ? "sticky" : "static"}
        top={sticky ? 0 : undefined}
      >
        <HStack>
          <HStack as={Link} pb={1} href={rootPath()}>
            <Image src={LogoSVG} h={7} />
          </HStack>
          {!isMinimal && (
            <Show above="lg">
              <Box ml={6} h="full">
                <ServiceLinks currentUser={currentUser} />
              </Box>
            </Show>
          )}
        </HStack>
        <Stack>
          <HStack h="full" gap={0}>
            {!isMinimal && <MessagesButton currentUser={currentUser} />}
            <Show above="lg">
              {currentUser ? (
                <Flex h="full" flexDirection={"row"}>
                  <Menu autoSelect={false} placement="bottom-end" offset={[-24, 8]}>
                    <Profile currentUser={currentUser} />
                    <ProfileMenuList currentUser={currentUser} logout={logout} />
                  </Menu>
                  {!isMinimal && currentUser.is_all_public_feature_accessible && (
                    <Button
                      leftIcon={<SmsIcon />}
                      iconSpacing={1}
                      as="a"
                      href={newPostPath()}
                      h="full"
                      borderRadius={0}
                      pl={3}
                      pr={4}
                      fontSize="sm"
                    >
                      質問を投稿
                    </Button>
                  )}
                </Flex>
              ) : (
                !hideAuthActions && <HeaderLoginActions />
              )}
            </Show>
            <Show below="lg">
              <Flex h="full" alignItems="center" mr={4}>
                <HeaderDrawerWithButton currentUser={currentUser} logout={logout} />
              </Flex>
            </Show>
          </HStack>
        </Stack>
      </Flex>
    </Box>
  );
};

export default GeneralHeader;
